import { defineStore } from "pinia";

import {
  Create,
  RegisterAdminPayload,
  Update,
  UpdateAdminPayload,
} from "../../service/user/interface/user.interface";
import userService from "../../service/user/user.service";
import { storeItem } from "../../core/utils/storage.helper";

interface State {
  error: { value: boolean; type: any | null; message: string | null };
}
const userStore = defineStore("user", {
  state: (): State => ({
    error: { value: false, type: null, message: null },
  }),

  actions: {
    // async show(id: string): Promise<any> {
    //   try {
    //     const response = await userService.show(id);
    //     if (response.data) {
    //       return await Promise.resolve(response);
    //     } else if (response.response) {
    //       return await Promise.reject(response.response);
    //     } else {
    //       return await Promise.reject(response.message);
    //     }
    //   } catch (error: any) {
    //     return await Promise.reject(error);
    //   }
    // },

    // async show(userId: number): Promise<any> {
    //   try {
    //     const response = await userService.show(userId);
    //     if (response && response.data && response.data.data) {
    //       console.log("_____\\\\\\\\_____",response.data.data.organisation.user.email);
    //       console.log("_____----_____",response.data.data);

    //       const data = JSON.stringify({
    //         customerInfo: {
    //           firstName: response.data.data.organisation.user.firstname,
    //           lastName: response.data.data.organisation.user.lastname,
    //           email: response.data.data.organisation.user.email,
    //           phone: response.data.data.organisation.user.email,
    //           // wallet: response.data.data.organisation.wallet.balance,
    //           organisationName: response.data.data.organisation.organisationName,
    //           organisationId: response.data.data.organisation.id,
    //           userId: response.data.data.organisation.userId,

    //         },
    //       });
    //       storeItem(import.meta.env.VITE_USERDETAILS, data);
    //       console.log("^^^^", data)
    //       return await Promise.resolve(response);
    //     } else if (response.response) {
    //       return await Promise.reject(response.response);
    //     } else {
    //       return await Promise.reject(response.message);
    //     }
    //   } catch (error: any) {
    //     return await Promise.reject(error);
    //   }
    // },

    async show(userId: number): Promise<any> {
      try {
        const response = await userService.show(userId);
        if (response && response.data && response.data.data) {
          const userData = response.data.data;
          let customerInfo;

          if (userData.organisation) {
            customerInfo = {
              firstName: userData.organisation.user?.firstname || '',
              lastName: userData.organisation.user?.lastname || '',
              email: userData.organisation.user?.email || '',
              phone: userData.organisation.user?.phone || '',
              organisationName: userData.organisation.organisationName || '',
              organisationId: userData.organisation.id,
              userId: userData.organisation.userId,
              imageUrl: userData.organisation.user?.imageUrl || '',
            };
          } else if (userData.employee) {
            customerInfo = {
              firstName: userData.employee.user?.firstname || '',
              lastName: userData.employee.user?.lastname || '',
              email: userData.employee.user?.email || '',
              phone: userData.employee.user?.phone || '',
              organisationName: userData.employee.organisation?.organisationName || '',
              organisationId: userData.employee.organisation?.id || null,
              userId: userData.employee.userId,
              imageUrl: userData.employee.user?.imageUrl || '',
            };
          } else {
            throw new Error('Unknown user type');
          }

          const data = JSON.stringify({ customerInfo });
          storeItem(import.meta.env.VITE_USERDETAILS, data);
          return Promise.resolve(response);
        } else if (response.response) {
          return Promise.reject(response.response);
        } else {
          return Promise.reject(response.message);
        }
      } catch (error: any) {
        return Promise.reject(error);
      }
    },

     async verify(verify: string): Promise<any> {
      try {
        const response = await userService.verify(verify);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    // async getUsers(): Promise<any> {
    //   try {
    //     const response = await userService.getUsers();
    //     if (response.data) {
    //       return await Promise.resolve(response);
    //     } else if (response.response) {
    //       return await Promise.reject(response.response);
    //     } else {
    //       return await Promise.reject(response.message);
    //     }
    //   } catch (error: any) {
    //     return await Promise.reject(error);
    //   }
    // },

    async getUsers(organisationId: number, pageSize: number, pageNumber: number): Promise<any> {
      try {
        const response = await userService.getUsers(organisationId, pageSize, pageNumber);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },  

    async getAdminUsers(
      organisationId: number | undefined,
      pageSize: number,
      pageNumber: number
    ): Promise<any> {
      try {
        const response = await userService.getAdminUsers(
          organisationId,
          pageSize,
          pageNumber
        );
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async registerAdmin(payload: RegisterAdminPayload): Promise<any> {
      try {
        const response = await userService.registerAdmin(payload);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async fetchAdmin(userId: number): Promise<any> {
      try {
        const response = await userService.fetchAdmin(userId);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async updateAdmin(payload: UpdateAdminPayload): Promise<any> {
      try {
        const response = await userService.updateAdmin(payload);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async getNotifications(userId: number, pageSize: number, pageNumber: number): Promise<any> {
      try {
        const response = await userService.getNotifications(userId, pageSize, pageNumber);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async markNotificationAsRead(notificationId: number): Promise<any> {
      try {
        const response = await userService.markNotificationAsRead(notificationId);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },    

    async getUnreadCount(): Promise<any> {
      try {
        const response = await userService.getUnreadCount();

        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async deleteNotification(id: number): Promise<any> {
      try {
        const response = await userService.deleteNotification(id);

        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async deleteAllNotifications(): Promise<any> {
      try {
        const response = await userService.deleteAllNotifications();

        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async getUserRole(userId: number): Promise<any> {
      try {
          const response = await userService.getUserRoleById(userId);
          console.log("Response from service:", response); 
          if (response.succeeded) {
              return response.data; 
          } else {
              throw new Error(response.message);
          }
      } catch (error: any) {
          console.error("Error in getUserRole:", error); 
          throw error; 
      }
  },     
    async fetchRoles(): Promise<any> {
      try {
        const response = await userService.fetchRoles();
        if (response.data) {
          return await Promise.resolve(response.data.data);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    
    async assignRole(userId: number, roleId: number): Promise<any> {
      try {
        const response = await userService.assignRole({ userId, roleId });
        console.log("Responseeeeeeee:", response);
        if (response.data) {
          return await Promise.resolve(response.data);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async updateRole(userId: number, roleId: number): Promise<any> {
      try {
          const response = await userService.updateRole(userId, roleId);
          if (response.data) {
              return await Promise.resolve(response.data);
          } else if (response.response) {
              return await Promise.reject(response.response);
          } else {
              return await Promise.reject(response.message);
          }
      } catch (error: any) {
          return await Promise.reject(error);
      }
  },  

  async submitKycInfo(kycData: {
    organisationId: number;
    firstname: string;
    middlename?: string;
    lastname: string;
    phone: string;
    email: string;
    gender: string;
    country: string;
    address: string;
    bvn: string;
  }): Promise<any> {
    try {
      const response = await userService.submitKycInfo(kycData);
      
      if (response && response.data && response.data.succeeded) {
        console.log("KYC submission successful:", response.data);
        return await Promise.resolve(response);
      } else if (response.response) {
        return await Promise.reject(response.response);
      } else {
        return await Promise.reject(response.message || "KYC submission failed");
      }
    } catch (error: any) {
      console.error("Error submitting KYC:", error);
      return await Promise.reject(error);
    }
  },

  // async submitKycDocuments(documentData: {
  //   organisation_id: number;
  //   files: File[];
  // }): Promise<any> {
  //   try {
  //     const response = await userService.submitKycDocuments(documentData);
      
  //     if (response && response.data && response.data.succeeded) {
  //       console.log("KYC document submission successful:", response.data);
  //       return await Promise.resolve(response);
  //     } else if (response.response) {
  //       return await Promise.reject(response.response);
  //     } else {
  //       return await Promise.reject(response.message || "KYC document submission failed");
  //     }
  //   } catch (error: any) {
  //     console.error("Error submitting KYC documents:", error);
  //     return await Promise.reject(error);
  //   }
  // },

async submitKycDocuments(documentData: {
  organisation_id: number;
  files: { file: File; documentType: string }[];
}): Promise<any> {
  try {
    const response = await userService.submitKycDocuments(documentData);
    
    if (response && response.data && response.data.succeeded) {
      console.log("KYC document submission successful:", response.data);
      return await Promise.resolve(response);
    } else if (response.response) {
      return await Promise.reject(response.response);
    } else {
      return await Promise.reject(response.message || "KYC document submission failed");
    }
  } catch (error: any) {
    console.error("Error submitting KYC documents:", error);
    return await Promise.reject(error);
  }
},

async fetchKycDocuments(organisationId: number): Promise<any> {
  try {
    const response = await userService.getKycDocuments(organisationId);

    if (response && response.data && response.data.succeeded) {
      console.log("KYC documents fetched:", response.data.data);
      return await Promise.resolve(response.data.data);
    } else if (response.response) {
      return await Promise.reject(response.response);
    } else {
      return await Promise.reject(response.message || "Failed to fetch KYC documents");
    }
  } catch (error: any) {
    console.error("Error fetching KYC documents:", error);
    return await Promise.reject(error);
  }
},

async fetchKycStatus(organisationId: number): Promise<any> {
  try {
    const response = await userService.getKycStatus(organisationId);
    
    if (response && response.data && response.data.succeeded) {
      console.log("KYC status fetched:", response.data.data);
      return await Promise.resolve(response.data.data);
    } else if (response.response) {
      return await Promise.reject(response.response);
    } else {
      return await Promise.reject(response.message || "Failed to fetch KYC status");
    }
  } catch (error: any) {
    console.error("Error fetching KYC status:", error);
    return await Promise.reject(error);
  }
},

async checkKycStatus(organisationId: number): Promise<boolean> {
  try {
    const response = await userService.getKycStatus(organisationId);
    
    if (response?.data?.succeeded) {
      const hasDocuments = response.data.data?.documents?.length > 0;
      const isApprovedOrPending = ['Approved', 'Pending'].includes(response.data.data?.status);
      
      return hasDocuments && isApprovedOrPending;
    }
    return false;
  } catch (error) {
    console.error("Error checking KYC status:", error);
    return false;
  }
},
    
  // async submitKycDocuments(docPayload: { organisationId: number; files: File[] }): Promise<any> {
  //   try {
  //     const response = await userService.submitKycDocuments(docPayload);
  
  //     if (response && response.data && response.data.succeeded) {
  //       console.log("Document submission successful:", response.data);
  //       return Promise.resolve(response);
  //     } else if (response.response) {
  //       return Promise.reject(response.response);
  //     } else {
  //       return Promise.reject(response.message || "Document submission failed");
  //     }
  //   } catch (error: any) {
  //     console.error("Error submitting documents:", error);
  //     return Promise.reject(error);
  //   }
  // },
  
  async deleteUser(userId: string): Promise<any> {
      try {
        const response = await userService.deleteUser(userId);
        if (response.data) {
          return await Promise.resolve(response.data);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async create(data: Create): Promise<any> {
      try {
        const response = await userService.create(data);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async update(data: Update, id: string): Promise<any> {
      try {
        const response = await userService.update(data, id);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async delete(id: string): Promise<any> {
      try {
        const response = await userService.delete(id);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async updateUserImage(userId: number, formData: FormData): Promise<any> {
      try {
        const response = await userService.updateUserImage(userId, formData);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    }

  },
});

export default userStore;
